$(function() {
    if ($('ul.tabs').length) {
        $('ul.tabs li').off('click').on('click', function (e) {
            var active = $(this).data('tab');
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            $('.tabs-content .tab.active').removeClass('active');
            $('.tabs-content .' + active).addClass('active');
        })
    }
});
